import React from "react";
import StockCountLine from "../../../../utilities/data/model/StockCountLine";

export type SelectedStockCountItemType = {
  stockCountLineItem: StockCountLine;
};

export const SelectedStockCountItemContext = React.createContext<
  SelectedStockCountItemType | undefined
>(undefined);
